import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">
        <p class="poem-block mb-5 text-center">
          1
        </p>

        <p class="poem-block mb-3">
          Я маленький человечек из маленькой, но единой Европы.<br/>
          Я живу в маленьком, но собственном доме,<br/>
          У меня небольшой доход и небольшое семейство, <br/>
          Но всё же я должен рассчитывать каждую мелочь:<br/>
          Сколько стоит сейчас обучение в университете, <br/>
          Сколько – на отпуск, сколько – на частную школу, <br/>
          Сколько денег останется на моём счёте в банке<br/>
          После покупки нового автомобиля и 7-ого айфона:<br/>
          Ведь невозможно же показаться на люди<br/>
          Со старою, прошлогодней моделью: <br/>
          Меня засмеют, я потеряю престиж свой<br/>
          И не получу прибавки к зарплате; тогда из чего же<br/>
          Я выплачу новый кредит на покупку айфона-8?
        </p>
        
        <p class="poem-block mb-5">
          Я маленький человечек из маленькой, но единой Европы,<br/>
          И маленькие заботы гнетут в этом маленьком мире.<br/>
          Но если чужие ракеты приблизятся к нашим границам, <br/>
          Станет холодным и мёртвым комфортное наше жилище<br/>
          И никакие стены не спасут от ядерной бомбы.<br/>
          И маленькие наши заботы сольются в одно большое<br/>
          Желание, крик всеобщий всех обитателей мира:<br/>
          Оставим нашу планету живой, голубой и зелёной,<br/>
          Пригодной для всякой жизни, просто для жизни на свете.<br/>
          Не будет больше русских, французов или американцев – <br/>
          Останутся только люди, землян разумная раса,<br/>
          Венец творения, а не слепой его разрушитель. 
        </p>
        
        <p class="poem-block mb-5 text-center">
          2
        </p>
        
        <p class="poem-block mb-5">
          Нам сообщают газеты:
          Сегодня погибло столько-то, 
          Убитых, взорванных – столько-то,
          Задавленных, обезглавленных – столько-то.
          Но хватит уже, довольно!
          Земле от сражений  больно,
          Она содрогается в гневе 
          И вот вместо стран – провалы,
          Глубокие, будто раны
          На лике земном. Бушуют
          И смерчи, и ураганы,
          И правых, и виноватых
          Сметая одним движеньем.
          Всё ж верим мы в возрожденье.
          Но не процветанье – 
          Нищанье
          И сладкоречивое лганье
          От наших вождей продажных,
          От наших писак бумажных,
          Готовых за пайку хлеба
          Продать и Землю, и небо.
          Как пышут они благородством!
          Каким потакают уродствам!
          А мы, как покорные дети, 
          Идём в нас манящие сети
          И всё повторяем, что надо,
          Как жвачку жующее стадо…
          Ах как прославляют поэты
          Военные подвиги эти,
          Несущие мир и свободу
          Порабощённым народам!
          Лишь только народа не жалко,
          Погибшего в этой свалке…
          Ах как горят поля!
          Пылает вся наша Земля.
          И в нашем уютном мире,
          И в нашей отдельной квартире 
          Всё явственней запах дыма, 
          И пули пока ещё мимо
          Проносятся, но уж скоро…
          Не выбиться нам из хора!
          Властной рукой ведомы,
          Сожжём и мы свои домы.
          Готовые к послушанью, 
          Сами пойдём на закланье, 
          Пойдём под свистящую плеть:
          Слушаться и терпеть!
          Вот твой удел, Европа…
        </p>
      </div>
    `
  )
}

const itemName = {
  rus: 'Песни маленького человека из маленькой Европы, XX век'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;